var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 .935c-5.523 0-10 4.476-10 10 0 4.236 2.636 7.855 6.355 9.312-.087-.79-.165-2.004.035-2.87.181-.78 1.173-4.97 1.173-4.97s-.3-.599-.3-1.484c0-1.39.806-2.429 1.81-2.429.853 0 1.265.641 1.265 1.41 0 .857-.546 2.14-.828 3.329-.236.996.5 1.807 1.48 1.807 1.778 0 3.144-1.875 3.144-4.58 0-2.395-1.72-4.068-4.177-4.068-2.844 0-4.514 2.134-4.514 4.34 0 .859.33 1.78.743 2.282.082.1.093.186.07.287-.076.316-.245.995-.278 1.134-.044.183-.145.222-.336.134-1.248-.581-2.028-2.408-2.028-3.874 0-3.154 2.292-6.052 6.607-6.052 3.469 0 6.165 2.472 6.165 5.776 0 3.446-2.174 6.22-5.189 6.22-1.014 0-1.966-.527-2.293-1.149l-.622 2.377c-.226.869-.836 1.957-1.243 2.621.935.291 1.93.447 2.961.447 5.523 0 10-4.477 10-10 0-5.524-4.477-10-10-10",
    fill: "currentcolor",
    fillRule: "nonzero"
  })));
};

export default SvgPinterest;